import t from 'react-translate';
import { css } from '@emotion/react';
import React from 'react';
import { novoEdBlue } from 'athena/styles/colors';
import ExpertMentoringGuides from './expert-mentoring-guides';
import ParticipantExperience from './participant-experience';
import { PROGRAM_CONFIGURATION_SECTION_WIDTH } from '../../constants';

const styles = css`
  max-width: ${PROGRAM_CONFIGURATION_SECTION_WIDTH}px;

  a {
    color: ${novoEdBlue};
  }
`;

const Guidance = () => {
  const translationBase = t.MENTORING_PROGRAMS.SETTINGS.TABS.GUIDANCE;

  return (
    <div css={styles} className='mx-auto'>
      <div className='title heading-2 mb-2'>{translationBase.TITLE()}</div>
      <div className='text-body black mb-6'>
        {translationBase.DESCRIPTION()}
      </div>
      <ExpertMentoringGuides />
      <ParticipantExperience />
    </div>
  );
};

export default Guidance;
